<template>
	<div>
		<v-row>
			<v-col sm="12">
				<v-dialog v-model="dialog" width="500" >
					<template v-slot:activator="{ props: activatorProps }">
						<v-btn  dark v-bind="activatorProps" >
							Novo gráfico
						</v-btn>
					</template>
					<v-card>
						<v-card-title class="text-h5 grey lighten-2">
							Novo Gráfico
						</v-card-title>
						<v-card-text class="pa-4">
							<v-select
								label="índice"
								:items="computedOptionsCols"
								v-model="params.colname"></v-select>
							<v-select
								label="Tipo de gráfico"
								:items="['line','bar','pie']"
								v-model="params.type"></v-select>
							<v-text-field  label="Título do gráfico"
								v-model="params.title"></v-text-field>
							<v-checkbox v-model="params.showLegends" label="Legendas"></v-checkbox>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn text @click="addChart">
								Adicionar
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-col>
			<v-col sm="6" v-for="chart, index in charts" :key="index">
				<div>
					<v-btn icon small @click="charts.splice(index,1)">
						<v-icon small color="error">mdi-delete</v-icon>
					</v-btn>
					<Chart :dataOptions="chart" />
				</div>
			</v-col>
		</v-row>
	</div>
</template>
<script>
import Chart from './Chart.vue'
export default {
	components:{
		Chart
	},
	data:()=>({
		dialog:false,
		params:{
			colname:null,
			type:null,
			title:'',
			showLegends:true,
			showZoomControls:true
		},
		modelParams:{
			colname:null,
			type:null,
			title:'',
			showLegends:true,
			showZoomControls:true
		},
		charts:[],
		base:[
			{
				CODCOLIGADA: 1,
				RA: "001-006328",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "RECANTO DOS VINHAIS",
				ESTADO: "MA",
				CIDADE: "SÃO LUÍS",
				CODGRAUINSTRUCAO: "6",
				GRAUINSTRUCAO: "Ensino médio incompleto",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-008655",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "-",
				CODSTATUS: 45,
				SMASTATUS: "NAO APTO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "PONTA DA AREIA ",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-016660",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "-",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "SAO LUIS",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-016971",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 15,
				TIPOALUNO: "INATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 22,
				TIPOINGRESSO: "READMISSAO APÓS TRANCAMENTO",
				CODTURMA: "-",
				CODSTATUS: 45,
				SMASTATUS: "NAO APTO",
				ANOMAT: 2023,
				MESMAT: 3,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "ANJO DA GUARDA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-017058",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 15,
				TIPOALUNO: "INATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "-",
				CODSTATUS: 34,
				SMASTATUS: "PRE-MATRICULA",
				ANOMAT: 2023,
				MESMAT: 3,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "RENASCENÇA",
				ESTADO: "MA",
				CIDADE: "SAO LUIS",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 23,
				STATUSHAB: "ABANDONO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-017192",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "PLANALTO VINHAIS II",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-017672",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "JARDIM RENASCENCA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-017925",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "-",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "IVAR SALDANHA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-018048",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "SÃO CRISTOVÃO",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-018664",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 18,
				TIPOMAT: "MATRICULA",
				CODTIPOINGRESSO: 19,
				TIPOINGRESSO: "ENEM - FIES",
				CODTURMA: "AD08AN",
				CODSTATUS: 52,
				SMASTATUS: "REMANEJADO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "ANJO DA GUARDA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 52,
				STATUSHAB: "REMANEJADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-003746",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 11,
				TIPOINGRESSO: "READMISSAO",
				CODTURMA: "-",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "BAIRRO UNIAO",
				ESTADO: "PA",
				CIDADE: "PARAUAPEBAS",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-008470",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 15,
				TIPOALUNO: "INATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 23,
				SMASTATUS: "ABANDONO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "JARDIM AMERICA",
				ESTADO: "MA",
				CIDADE: "SÃO LUÍS",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 23,
				STATUSHAB: "ABANDONO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-009522",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 11,
				TIPOINGRESSO: "READMISSAO",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "CHACARA BRASIL",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-009544",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "COROADINHO",
				ESTADO: "MA",
				CIDADE: "SÃO LUÍS",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-010425",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 22,
				TIPOINGRESSO: "READMISSAO APÓS TRANCAMENTO",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "J PAULO",
				ESTADO: "MA",
				CIDADE: "SÃO LUÍS",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-010448",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 15,
				TIPOALUNO: "INATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "-",
				CODSTATUS: 23,
				SMASTATUS: "ABANDONO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "OLHO D´AGUA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 23,
				STATUSHAB: "ABANDONO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-015946",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2023,
				MESMAT: 1,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "VINHAIS",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "001-005217",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 22,
				TIPOINGRESSO: "READMISSAO APÓS TRANCAMENTO",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "SAO FRANCISCO",
				ESTADO: "MA",
				CIDADE: "SÃO LUÍS",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "001-006703",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 13,
				TIPOINGRESSO: "TRANSFERENCIA INTERNA DE CURSO",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "PONTA DA AREIA",
				ESTADO: "MA",
				CIDADE: "SÃO LUÍS",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "001-007533",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "RENASCENÇA II",
				ESTADO: "MA",
				CIDADE: "SÃO LUÍS",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "001-008205",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 13,
				TIPOINGRESSO: "TRANSFERENCIA INTERNA DE CURSO",
				CODTURMA: "AD08AN",
				CODSTATUS: 45,
				SMASTATUS: "NAO APTO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "calhau",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "6",
				GRAUINSTRUCAO: "Ensino médio incompleto",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 1,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-008952",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 15,
				TIPOALUNO: "INATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 23,
				SMASTATUS: "ABANDONO",
				ANOMAT: 2023,
				MESMAT: 3,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "ARACAGI",
				ESTADO: "MA",
				CIDADE: "SÃO LUÍS",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-015788",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 112,
				SMASTATUS: "MUDANÇA DE ESTRUTURA",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "COROADINHO",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 112,
				STATUSHAB: "MUDANÇA DE ESTRUTURA",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-016727",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "TURU",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-019842",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 18,
				TIPOINGRESSO: "ENEM",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "RENASCENCA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-020111",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 13,
				TIPOINGRESSO: "TRANSFERENCIA INTERNA DE CURSO",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "JARDIM ELDORADO",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-020112",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 45,
				SMASTATUS: "NAO APTO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "BAIRRO",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-020116",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 45,
				SMASTATUS: "NAO APTO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "JARDIM TURU II ",
				ESTADO: "MA",
				CIDADE: "São José de Ribamar",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-020124",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 22,
				TIPOINGRESSO: "READMISSAO APÓS TRANCAMENTO",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "ESPERANÇA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 1,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-020307",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "ARIRIZAL",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-020325",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 13,
				TIPOINGRESSO: "TRANSFERENCIA INTERNA DE CURSO",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "CIDADE OPERARIA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 1,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-020374",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "COHAMA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "6",
				GRAUINSTRUCAO: "Ensino médio incompleto",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-020748",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "CIDADE OLIMPICA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-020750",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 34,
				SMASTATUS: "PRE-MATRICULA",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "VICENTE FIALHO",
				ESTADO: "MA",
				CIDADE: "SAO LUIS",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-020766",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 45,
				SMASTATUS: "NAO APTO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "ANIL",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-020864",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "SITIO DA NATUREZA",
				ESTADO: "MA",
				CIDADE: "Paço do Lumiar",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-020923",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 18,
				TIPOINGRESSO: "ENEM",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "CIAL ANIL",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021038",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "ARARAS",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021040",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "CENTRO",
				ESTADO: "MA",
				CIDADE: "Pirapemas",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021086",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "COHATRAC IV",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021161",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 18,
				TIPOINGRESSO: "ENEM",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "CALHAU",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021226",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "LIBERDADE",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021239",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "PALMEIRA ",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021278",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "JARDIM AMERICA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 1,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021304",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "VILA ALONSO COSTA",
				ESTADO: "MA",
				CIDADE: "São José de Ribamar",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021307",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "DIVINEIA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021385",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "COHAMA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021409",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "COHATRAC",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021419",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 12,
				TIPOINGRESSO: "TRANSFERENCIA EXTERNA DE CURSO",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "RESIDENCIAL RIBEIRA",
				ESTADO: "MA",
				CIDADE: "SÃO LUÍS",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021439",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "FIALHO",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021469",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "PONTA DAREIA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021511",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "LIBERDADE",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021514",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 18,
				TIPOINGRESSO: "ENEM",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "PARQUE ATHENAS",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021543",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "Maiobinha",
				ESTADO: "MA",
				CIDADE: "São José de Ribamar",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-021632",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 8,
				TIPOINGRESSO: "VESTIBULAR",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "VILA DOS NOBRES",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-022050",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 12,
				TIPOINGRESSO: "TRANSFERENCIA EXTERNA DE CURSO",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "SANTA EFIGÊNIA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-022108",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 12,
				TIPOINGRESSO: "TRANSFERENCIA EXTERNA DE CURSO",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "CALHAU ",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "7",
				GRAUINSTRUCAO: "Ensino médio completo",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-022730",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 12,
				TIPOINGRESSO: "TRANSFERENCIA EXTERNA DE CURSO",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "RECANTO DOS VINHAIS ",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-022809",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 9,
				TIPOINGRESSO: "ENEM - PROUNI",
				CODTURMA: "AD07AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "AMERICA",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-023079",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 12,
				TIPOINGRESSO: "TRANSFERENCIA EXTERNA DE CURSO",
				CODTURMA: "AD08AN",
				CODSTATUS: 33,
				SMASTATUS: "MATRICULADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 8,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "VILA LUIZAO",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 33,
				STATUSHAB: "MATRICULADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			},
			{
				CODCOLIGADA: 1,
				RA: "002-023684",
				CODFILIAL: 2,
				IDPERLET: 101,
				CODPERLET: "2023.1",
				CODTIPOALUNO: 14,
				TIPOALUNO: "ATIVO",
				CODTIPOMAT: 19,
				TIPOMAT: "REMATRICULA",
				CODTIPOINGRESSO: 12,
				TIPOINGRESSO: "TRANSFERENCIA EXTERNA DE CURSO",
				CODTURMA: "AD08AN",
				CODSTATUS: 52,
				SMASTATUS: "REMANEJADO",
				ANOMAT: 2022,
				MESMAT: 12,
				PERIODO: 7,
				SIT_INST_ENADE: "-",
				SIT_MEC_ENADE: "Nenhum",
				SIT_ENADE: "-",
				BAIRRO: "RECANTO DOS VINHAIS",
				ESTADO: "MA",
				CIDADE: "São Luís",
				CODGRAUINSTRUCAO: "-",
				GRAUINSTRUCAO: "-",
				FUNCIONARIO: 0,
				USUARIOBIBLIOS: 0,
				EXFUNCIONARIO: 0,
				CANDIDATO: 0,
				CODSTATUSHAB: 52,
				STATUSHAB: "REMANEJADO",
				CODTURNO: 10,
				TURNO: "NOTURNO",
				CODHABILITACAO: "BAC",
				HABILITACAO: "BACHARELADO",
				CODCURSO: "ADM",
				CURSO: "ADMINISTRAÇÃO",
				CODTIPOCURSO: 2,
				TIPOCURSO: "GRADUAÇÃO",
				CODAREA: 5,
				AREA: "CIENCIAS SOCIAIS APLICADAS",
				CODMODALIDADECURSO: "2",
				MODALIDADECURSO: "GRADUACAO"
			}
		],
	}),
	methods:{
		getChartTypeOptions(){
			const type = this.params.type
			const {labels,series} = this.getSeries(this.params.colname)
            let chartTypes = {
                line:{
                    series: series,//[{ name: "Desktops", data: [10, 41, 35, 51, 49, 62, 69, 91, 148] }],
                    options: {
						subtitle: {
							text: this.params.title,
							align: 'left',
							margin: 10,
							floating: false,
							style: {
								fontSize:  '10px',
								fontWeight:  'bold',
								fontFamily:  undefined,
								color:  '#9699a2'
							},
						},
                        chart: {
                            type: 'line',
                            zoom: {
                                enabled: this.params.showZoomControls
                            }
                        },
                        dataLabels: {
                            enabled: this.params.showLegends
                        },
                        stroke: {
                            curve: 'straight'
                        },
                        title: {
                            text: this.params.title,
                            align: 'left'
                        },
                        grid: {
                            row: {
                                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                                opacity: 0.5
                            },
                        },
                        xaxis: {
                            categories: labels, //['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
                        },
                        tooltip: {
                            theme: false,
                        },
						legend: {
							show: this.params.showLegends,
							fontSize: '10px',
						}
                    },
                },
                bar:{
                    series: series,//[{ name: "Desktops", data: [40, 43, 25, 41, 99, 42, 19, 11, 128] }],
                    options: {
                        chart: {
                            type: 'bar',
                            zoom: {
                                enabled: this.params.showZoomControls
                            }
                        },
                        dataLabels: {
                            enabled: this.params.showLegends
                        },
                        stroke: {
                            curve: 'straight'
                        },
                        title: {
                            text: this.params.title,
                            align: 'left'
                        },
                        grid: {
                            row: {
                                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                                opacity: 0.5
                            },
                        },
                        xaxis: {
                            categories: labels,//['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
                        },
						tooltip: {
                            theme: false,
                        },
						legend: {
							show: this.params.showLegends,
							fontSize: '10px',
						}
                    },
                },
                pie:{
                    series: series[0].data,
                    options: {
                        chart: {
                            type: 'pie',
							zoom: {
                                enabled: this.params.showZoomControls
                            }
                        },
                        labels: labels,
						legend: {
							show: this.params.showLegends,
							fontSize: '10px',
						}
                    },
                },
            }
            const chartOptions = chartTypes[type]
            return chartOptions
		},
		addChart(){
			// const {labels,series} = this.getSeries(this.params.colname)
			const dataOptions = this.getChartTypeOptions()
			this.charts.push(dataOptions)
			this.params = Object.assign({},this.modelParams)
			this.dialog = false
		},
		getSeries(selectedCol){
			const coluna = selectedCol
			var labels = []
			var  series = []
			if(coluna){
				// Realiza o new Set para remover duplicidade e incluir de volta spread como uma lista normal
				labels = [...new Set(this.base.map(o=> (o[coluna])))]
				// Realizar o count pra cada valor
				series = labels.map(o => this.base.filter(f=>f[coluna] == o).length )
				series = [{
					name: coluna || '',
					data: series
				}]
			}
			return {labels, series}
		}
	//     getDataValuesOption(option){
	//         console.log(option)
	//         const coluna = option
	//         var legendas = []
	//         var datavalues = []
	//         if(coluna){
	//             // Realiza o new Set para remover duplicidade e incluir de volta spread como uma lista normal
	//             legendas = [...new Set(this.base.map(o=> (o[coluna])))]
	//             // Realizar o count pra cada valor
	//             datavalues = legendas.map(o => this.base.filter(f=>f[coluna] == o).length )
	//         }
	//         datavalues
	//         // const resultOptions = {
	//         //     options: {
	//         //         tooltip: {
	//         //             enabled: true,
	//         //             enabledOnSeries: undefined,
	//         //             shared: true,
	//         //             followCursor: true,
	//         //             intersect: false,
	//         //             inverseOrder: false,
	//         //             custom: undefined,
	//         //             fillSeriesColor: false,
	//         //             theme: false,
	//         //             style: {
	//         //                 fontSize: '12px',
	//         //                 fontFamily: undefined
	//         //             },
	//         //             onDatasetHover: {
	//         //                 highlightDataSeries: true,
	//         //             },
	//         //             x: {
	//         //                 show: true,
	//         //                 format: 'dd MMM',
	//         //                 formatter: undefined,
	//         //             },
	//         //             y: {
	//         //                 formatter: undefined,
	//         //                 title: {
	//         //                     formatter: (seriesName) => seriesName,
	//         //                 },
	//         //             },
	//         //             z: {
	//         //                 formatter: undefined,
	//         //                 title: 'Size: '
	//         //             },
	//         //             marker: {
	//         //                 show: true,
	//         //             },
	//         //             items: {
	//         //                 display: 'flex',
	//         //             },
	//         //             // fixed: {
	//         //             //     enabled: false,
	//         //             //     position: 'topRight',
	//         //             //     offsetX: 0,
	//         //             //     offsetY: 0,
	//         //             // },
	//         //         },
	//         //         title: {
	//         //             text: coluna,
	//         //             align: 'center',
	//         //             margin: 10,
	//         //             offsetX: 0,
	//         //             offsetY: 0,
	//         //             floating: false,
	//         //             style: {
	//         //                 fontSize:  '14px',
	//         //                 fontWeight:  'bold',
	//         //                 fontFamily:  undefined,
	//         //                 color:  'gray'
	//         //             },
	//         //         },
	//         //         markers: {
	//         //             size: 0,
	//         //         },
	//         //         stroke: {
	//         //         curve: 'smooth',
	//         //         },
	//         //         theme: {
	//         //             // palette: 'palette8',
	//         //             monochrome: {
	//         //                 enabled: true,
	//         //                 color: '#255aee',
	//         //                 shadeTo: 'dark',
	//         //                 shadeIntensity: 0.9
	//         //             }
	//         //         },
	//         //         chart: {
	//         //             id: coluna,
	//         //             type: 'pie',
	//         //         },
	//         //         xaxis: {
	//         //             categories: legendas
	//         //         },
	//         //         dataLabels: {
	//         //             enabled: true,
	//         //             formatter: function (val) {
	//         //                 return val + "%"
	//         //             },
	//         //         }
	//         //         // fill: {
	//         //         //     type: "gradient",
	//         //         //     gradient: {
	//         //         //     shadeIntensity: 1,
	//         //         //     opacityFrom: 0.7,
	//         //         //     opacityTo: 0.9,
	//         //         //     stops: [0, 90, 100]
	//         //         //     }
	//         //         // },
	//         //     },
	//         //     series: [{
	//         //         name: (coluna||'-'),
	//         //         data: datavalues
	//         //     }]
	//         // }
	//         // this.charts.push(resultOptions)
	//     },
	},
	computed:{
		computedOptionsCols(){
			try{
				return Object.keys(this.base[0])
			}catch{
				return []
			}
		},
		// computedDataValues(){
		//     const coluna = this.coluna
		//     var legendas = []
		//     var datavalues = []
		//     if(coluna){
		//         // Realiza o new Set para remover duplicidade e incluir de volta spread como uma lista normal
		//         legendas = [...new Set(this.base.map(o=> (o[coluna])))]
		//         // Realizar o count pra cada valor
		//         datavalues = legendas.map(o => this.base.filter(f=>f[coluna] == o).length )
		//     }
		//     const resultOptions = {
		//         options: {
		//             chart: {
		//                 id: 'vuechart-example'
		//             },
		//             xaxis: {
		//                 categories: legendas
		//             }
		//         },
		//         series: [{
		//             name: (coluna||'-'),
		//             data: datavalues
		//         }]
		//     }
		//     return resultOptions
		// }
	}
}
</script>